import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import situations from "./content/situations.json";
import SituationCard from "./SituationCard";
import SEOHelmet from "./SEOHelmet";

export default function HireMe() {
  return (
    <>
      <SEOHelmet
        title="Hire Rick Molenaar - IT Management Consulting Services"
        description="Whether your organization is navigating a leadership gap, managing complex change, or looking to sharpen how your tech teams operate, it's not always clear where to start or who to turn to."
        canonicalUrl="https://rickmolenaar.me/hireme"
      />
      <>
        <Container fluid className="bg-theme-primary pt-3">
          <Row className="mb-3 mx-3">
            <Col className="msb-2">
              <h1 className="text-theme-accent1">Hire me</h1>
              <p className="text-theme-accent3">
                Engineering Management is my thing. I understand the technical depth engineers work in, which means my empathy is informed: I know when something is genuinely hard, when a decision needs more time, and when a better approach is worth pushing for. But technical understanding alone doesn't make a leader. Navigating complexity also requires creating real trust, making bold decisions, and holding people to a high standard, while staying comfortable with the fact that scope is discovered along the way and complexity can't be fully estimated upfront.
              </p>
              <p className="text-theme-accent3">
                I join management teams when something has to change: a departure that left a gap, a restructure that needs to hold, a team that has to scale, or a problem too complex to hand to someone still finding their footing. I dig in, address structural problems, bring in and onboard new leadership where needed, and stay until the job is done.
              </p>
              <p className="text-theme-accent3">
                See below on situations where I can help or{" "}
                <a href="./connect">get in touch</a>
                {" "}directly.
              </p>
            </Col>
          </Row>
          <Row className="mt-1 ms-1">
            {situations.map((situation, index) => (
              <Col
                data-testid="situation-card"
                sm={12}
                md={7}
                lg={4}
                className="mb-5"
                key={"situation_" + index}
              >
                <SituationCard data={situation} />
              </Col>
            ))}
          </Row>
        </Container>
      </>
    </>
  );
}
